var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackWave3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#eeeeee",
      display: "block",
      zIndex: 1,
      position: "relative"
    },
    width: 1536,
    height: 684,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1536 684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(768,342) scale(1,1) translate(-768,-342)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.3116570175632063",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3490b8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20dacd",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.3116570175632063)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "0s",
    values: "M0 0L 0 559.851527798018Q 192 396.9158215718689  384 359.5474300332975T 768 380.00944997699577T 1152 491.6458730796692T 1536 346.53055828040357L 1536 0 Z;M0 0L 0 563.7291062792514Q 192 453.28468569929476  384 408.1692743447073T 768 525.5482140341744T 1152 409.09633297661867T 1536 545.1935972137727L 1536 0 Z;M0 0L 0 524.0700361901764Q 192 439.4850882579574  384 413.4550343893376T 768 558.6591351218735T 1152 407.767797164287T 1536 525.0876727626566L 1536 0 Z;M0 0L 0 559.851527798018Q 192 396.9158215718689  384 359.5474300332975T 768 380.00944997699577T 1152 491.6458730796692T 1536 346.53055828040357L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.3116570175632063)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-5s",
    values: "M0 0L 0 529.4873406995931Q 192 430.68474087153106  384 414.5090307671976T 768 415.53897341647803T 1152 536.2412736374225T 1536 379.70283497314483L 1536 0 Z;M0 0L 0 402.64131646102385Q 192 510.05387657743626  384 488.34137325895176T 768 432.7165375018765T 1152 427.6921354887927T 1536 435.9892434720806L 1536 0 Z;M0 0L 0 562.1518050978846Q 192 574.3185037599285  384 527.799522346801T 768 477.70448869295467T 1152 385.95103049829675T 1536 487.61853620858074L 1536 0 Z;M0 0L 0 529.4873406995931Q 192 430.68474087153106  384 414.5090307671976T 768 415.53897341647803T 1152 536.2412736374225T 1536 379.70283497314483L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.3116570175632063)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-10s",
    values: "M0 0L 0 371.5237716816238Q 192 547.1202020565357  384 529.2937363198417T 768 379.0669586385191T 1152 377.62416625610723T 1536 419.8492292477309L 1536 0 Z;M0 0L 0 368.817395341027Q 192 464.42802042882465  384 428.7677687033961T 768 515.5511871070906T 1152 468.0960996198346T 1536 387.92591148528896L 1536 0 Z;M0 0L 0 338.86522675584933Q 192 410.629860344844  384 383.84633703555596T 768 498.85532253972474T 1152 557.7589522143621T 1536 371.14655451301735L 1536 0 Z;M0 0L 0 371.5237716816238Q 192 547.1202020565357  384 529.2937363198417T 768 379.0669586385191T 1152 377.62416625610723T 1536 419.8492292477309L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.3116570175632063)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-15s",
    values: "M0 0L 0 561.8643991955339Q 192 593.301810122197  384 561.2691695489849T 768 482.18992597779T 1152 506.66720273877365T 1536 478.8558977882351L 1536 0 Z;M0 0L 0 543.5003723494293Q 192 504.149036291391  384 483.0745382372236T 768 448.74384879064667T 1152 399.75797806009575T 1536 539.825763267823L 1536 0 Z;M0 0L 0 374.10535188803533Q 192 372.8974151823832  384 359.82855087783133T 768 448.9484806428698T 1152 439.39621427003914T 1536 405.7273107006374L 1536 0 Z;M0 0L 0 561.8643991955339Q 192 593.301810122197  384 561.2691695489849T 768 482.18992597779T 1152 506.66720273877365T 1536 478.8558977882351L 1536 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.3116570175632063)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "25s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcmod: "spline",
    keySplines: "0.2 0 0.2 1;0.2 0 0.2 1;0.2 0 0.2 1",
    begin: "-20s",
    values: "M0 0L 0 387.08184564911346Q 192 487.9279991077228  384 468.86234070153847T 768 398.2484912119553T 1152 549.9970219158502T 1536 464.22669186064775L 1536 0 Z;M0 0L 0 403.59893505522166Q 192 370.5066585000725  384 350.05831701087135T 768 540.5184734914069T 1152 535.534035537404T 1536 506.3509269013051L 1536 0 Z;M0 0L 0 527.841760692907Q 192 553.6472666699376  384 511.47107231474644T 768 430.45822223271233T 1152 557.7368965198802T 1536 420.8864378574584L 1536 0 Z;M0 0L 0 387.08184564911346Q 192 487.9279991077228  384 468.86234070153847T 768 398.2484912119553T 1152 549.9970219158502T 1536 464.22669186064775L 1536 0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWave3);
export default __webpack_public_path__ + "static/media/backWave3.ca5fd2d69e8a5720a129d2ccf02e7522.svg";
export { ForwardRef as ReactComponent };